import { useLayoutEffect, useRef } from 'react';
import {
  NavigationType,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

const scrollPositions = new Map<string, number>();

export function RouteScrollManager() {
  const { key, pathname } = useLocation();
  const navigationType = useNavigationType();
  const previousPathnameRef = useRef<string | null>(null);

  useLayoutEffect(() => {
    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useLayoutEffect(() => {
    const pathChanged = previousPathnameRef.current !== pathname;
    const savedScrollPosition = scrollPositions.get(key);
    previousPathnameRef.current = pathname;

    if (navigationType === NavigationType.Pop && savedScrollPosition !== undefined) {
      window.scrollTo({ top: savedScrollPosition, left: 0, behavior: 'auto' });
    }
    else if (pathChanged) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }

    return () => {
      scrollPositions.set(key, window.scrollY);
    };
  }, [key, navigationType, pathname]);

  return null;
}
